(function boot(){
if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded', boot); return;
}
const HOST = document.querySelector('[data-kc-host]');
if(!HOST) return;
if(HOST.dataset.kcReady) return;
HOST.dataset.kcReady = '1';
const CFG  = HOST.dataset;
const ROOT = HOST.attachShadow({mode:'open'});
ROOT.appendChild(HOST.querySelector('template').content.cloneNode(true));

(function injectStyle(){
  const s = document.createElement('style');
  s.textContent =
    '@keyframes kcspin{to{transform:rotate(360deg)}}' +
    '.kc-spin{display:inline-block;width:17px;height:17px;border:2px solid rgba(8,21,15,.3);' +
    'border-top-color:#08150F;border-radius:50%;animation:kcspin .8s linear infinite;' +
    'vertical-align:-3px;margin-right:9px}' +
    '.kc-bar{position:sticky;top:0;z-index:5;display:flex;align-items:center;' +
    'justify-content:space-between;gap:12px;background:#0E1311;padding:4px 0 14px;' +
    'margin-bottom:6px;border-bottom:1px solid #2C3833}' +
    '.kc-bar h1{margin:0;font-family:"Barlow Condensed",sans-serif;font-weight:700;' +
    'font-size:17px;letter-spacing:.12em;text-transform:uppercase;color:#F2F4F1}' +
    '.kc-close{background:#1C2622;border:1px solid #3C4A44;color:#F2F4F1;border-radius:10px;' +
    'padding:9px 14px;font-size:14px;cursor:pointer;font-family:Inter,system-ui,sans-serif;flex:none}' +
    '.kc-note2{font-size:12px;color:#8A9791;margin:8px 0 0;line-height:1.45}' +
    '.kc-copy{width:100%;margin-top:8px;background:#1C2622;border:1px solid #3C4A44;' +
    'color:#F2F4F1;border-radius:9px;padding:10px;font-size:13px;cursor:pointer;' +
    'font-family:Inter,system-ui,sans-serif}' +
    '.kc-tip{margin:12px 0 0;padding:10px 12px;border-radius:10px;border:1px solid #E8232A;' +
    'background:rgba(232,35,42,.12);color:#F2F4F1;font-size:14px;font-weight:600;line-height:1.4;' +
    'font-family:Inter,system-ui,sans-serif}' +
    '#kc-stageHint:not(:empty){display:block;margin:10px 0 0;padding:10px 12px;border-radius:10px;' +
    'border:1px solid #E8232A;background:rgba(232,35,42,.12);color:#F2F4F1;font-size:14px;' +
    'font-weight:600;line-height:1.4;text-align:center}' +
    '.guard.kc-off{opacity:.4}' +
    '.guard.kc-on .guard-tag{color:#E8232A}';
  ROOT.appendChild(s);
})();

HOST.style.cssText =
  'position:fixed;inset:0;z-index:2147483200;display:none;overflow-y:auto;' +
  '-webkit-overflow-scrolling:touch;margin:0;border-radius:0;padding:16px 14px 48px;';

const trigger = document.createElement('button');
trigger.type = 'button';
trigger.setAttribute('aria-haspopup', 'dialog');
trigger.textContent = 'Personnaliser mes prot\u00e8ge-tibias';
trigger.style.cssText =
  'display:block;width:100%;margin:18px 0;padding:18px 16px;border:0;border-radius:12px;' +
  'background:#E8232A;color:#fff;font-family:"Barlow Condensed",system-ui,sans-serif;' +
  'font-weight:700;font-size:19px;letter-spacing:.08em;text-transform:uppercase;' +
  'cursor:pointer;line-height:1.2;';

let anchorNode = HOST;
if(CFG.mountBefore){
  try{
    const t = document.querySelector(CFG.mountBefore);
    if(t && t.parentNode && !t.contains(HOST)) anchorNode = t;
  }catch(e){}
}
anchorNode.parentNode.insertBefore(trigger, anchorNode);

let scrollLock = '';
function openApp(){
  scrollLock = document.body.style.overflow;
  document.body.style.overflow = 'hidden';
  HOST.style.display = 'block';
  HOST.scrollTop = 0;
  requestAnimationFrame(() => { renderPreview(); });
}
function closeApp(){
  HOST.style.display = 'none';
  document.body.style.overflow = scrollLock;
}
trigger.addEventListener('click', openApp);

(function buildBar(){
  const wrap = ROOT.querySelector('.wrap');
  const bar = document.createElement('div');
  bar.className = 'kc-bar';
  bar.innerHTML = '<h1>Personnalisation</h1>' +
    '<button type="button" class="kc-close">Fermer</button>';
  wrap.insertBefore(bar, wrap.firstChild);
  bar.querySelector('.kc-close').addEventListener('click', closeApp);
})();

function srOnly(el){
  if(!el || el.dataset.kcHidden) return;
  el.style.position = 'absolute';
  el.style.width = '1px';
  el.style.height = '1px';
  el.style.padding = '0';
  el.style.margin = '-1px';
  el.style.overflow = 'hidden';
  el.style.clip = 'rect(0,0,0,0)';
  el.style.whiteSpace = 'nowrap';
  el.style.border = '0';
  el.style.opacity = '0';
  el.style.pointerEvents = 'none';
  el.dataset.kcHidden = '1';
}

if(CFG.hideSelector){
  try { document.querySelectorAll(CFG.hideSelector).forEach(srOnly); } catch(e){}
}

const LEGACY = [
  /nom\s*&?\s*num[e\u00e9]ro/i,
  /photo\s*gauche/i,
  /photo\s*droite/i,
  /envie\s*particuli/i
];

function labelOf(el){
  let lab = null;
  if(el.id){
    try { lab = document.querySelector('label[for="' + CSS.escape(el.id) + '"]'); } catch(e){}
  }
  if(!lab) lab = el.closest('label');
  if(!lab){
    let p = el.previousElementSibling;
    while(p && !/^(LABEL|P|SPAN|DIV|H\d|STRONG|B|LEGEND)$/.test(p.tagName)) p = p.previousElementSibling;
    if(p && (p.textContent || '').trim().length < 80) lab = p;
  }
  return lab;
}

function liveFields(){
  return [].slice.call(document.querySelectorAll('input, textarea, select'))
    .filter(f => !HOST.contains(f) && f.type !== 'hidden' && f.type !== 'submit');
}

function hideLegacyBlocks(){
  const fields = liveFields();
  const tags = 'p, label, span, div, legend, strong, b, h2, h3, h4, h5';

  [].slice.call(document.querySelectorAll(tags)).forEach(el => {
    if(HOST.contains(el) || el.dataset.kcHidden) return;
    if(el.querySelector('input, textarea, select, button')) return;

    const txt = (el.textContent || '').trim();
    if(!txt || txt.length > 70) return;
    if(!LEGACY.some(rx => rx.test(txt))) return;

    el.style.display = 'none';
    el.dataset.kcHidden = '1';

    const next = fields.find(f =>
      !f.dataset.kcHidden &&
      (el.compareDocumentPosition(f) & Node.DOCUMENT_POSITION_FOLLOWING));
    if(next) srOnly(next);
  });

  fields.forEach(el => {
    if(el.dataset.kcHidden) return;
    const lab = labelOf(el);
    const txt = ((lab ? lab.textContent : '') + ' ' + (el.name || '')).trim();
    if(txt && LEGACY.some(rx => rx.test(txt))){
      srOnly(el);
      if(lab && lab !== el){ lab.style.display = 'none'; lab.dataset.kcHidden = '1'; }
    }
  });
}

const SIZES = [
  { id:'xxxs', label:'XXXS', cm:'8 cm', refW:876.5, refH:1000.0,
    R:{ vbW:876.5, vbH:1000.0, path:'M159.4 40.4 L95.4 70.7 L38.2 117.8 L11.2 160.5 L0.0 209.9 L68.5 693.6 L89.8 798.0 L115.6 865.3 L141.4 902.4 L195.3 947.3 L257.0 975.3 L335.6 993.3 L396.2 998.9 L530.9 994.4 L607.2 978.7 L677.9 948.4 L714.9 921.4 L750.8 879.9 L772.2 838.4 L792.4 769.9 L875.4 235.7 L870.9 180.7 L855.2 143.7 L818.2 98.8 L772.2 66.2 L689.1 31.4 L593.7 10.1 L469.1 0.0 L354.7 2.2 L249.2 15.7 Z' },
    L:{ vbW:876.5, vbH:1000.0, path:'M150.4 43.8 L86.4 76.3 L39.3 116.7 L13.5 156.0 L0.0 206.5 L75.2 731.8 L92.0 805.8 L116.7 867.6 L142.5 903.5 L195.3 947.3 L244.7 970.8 L321.0 991.0 L396.2 998.9 L510.7 996.6 L599.3 980.9 L670.0 952.9 L716.0 920.3 L747.5 884.4 L774.4 832.8 L790.1 778.9 L873.2 255.9 L873.2 190.8 L857.5 147.0 L819.3 99.9 L767.7 64.0 L689.1 31.4 L585.9 9.0 L469.1 0.0 L340.1 3.4 L237.9 18.0 Z' } },
  { id:'xxs', label:'XXS', cm:'10 cm', refW:876.6, refH:1000.0,
    R:{ vbW:876.6, vbH:1000.0, path:'M138.8 48.6 L81.0 80.2 L38.6 118.0 L11.6 161.1 L0.0 212.8 L74.8 724.7 L96.4 818.0 L118.7 869.7 L153.4 914.4 L200.5 949.9 L267.5 978.4 L340.0 993.8 L473.4 999.2 L542.0 993.1 L613.7 976.9 L678.5 948.3 L715.5 921.4 L754.8 874.3 L792.6 771.0 L875.9 237.5 L873.6 189.7 L855.1 141.9 L812.6 93.3 L747.9 53.2 L670.0 25.4 L573.6 6.9 L482.7 0.0 L323.1 4.6 L221.3 21.6 Z' },
    L:{ vbW:876.6, vbH:1000.0, path:'M138.8 48.6 L83.3 78.6 L38.6 118.0 L11.6 161.1 L0.0 212.8 L76.3 733.2 L97.1 820.4 L121.0 873.6 L162.7 922.9 L207.4 953.7 L265.2 977.6 L340.0 993.8 L473.4 999.2 L542.0 993.1 L623.0 973.8 L682.3 946.0 L715.5 921.4 L754.8 874.3 L794.9 760.2 L875.9 237.5 L872.0 182.7 L852.7 138.0 L812.6 93.3 L747.9 53.2 L670.0 25.4 L573.6 6.9 L482.7 0.0 L323.1 4.6 L221.3 21.6 Z' } },
  { id:'xs', label:'XS', cm:'12 cm', refW:876.4, refH:1000.0,
    R:{ vbW:876.4, vbH:1000.0, path:'M142.8 47.1 L84.7 77.9 L36.9 120.2 L9.6 166.7 L0.0 217.2 L74.5 722.0 L94.3 810.1 L118.2 868.2 L157.8 918.0 L204.2 951.5 L270.5 978.8 L343.6 993.9 L454.9 999.3 L537.6 993.2 L610.0 977.5 L679.0 947.4 L713.8 922.1 L752.0 877.7 L791.7 773.2 L875.0 241.1 L873.6 192.6 L855.9 144.1 L814.9 95.6 L747.3 53.3 L666.0 24.6 L581.3 8.2 L474.7 0.0 L338.1 3.4 L226.8 20.5 Z' },
    L:{ vbW:876.4, vbH:1000.0, path:'M139.3 48.5 L82.7 79.2 L36.2 120.9 L10.2 164.6 L0.0 213.8 L76.5 733.6 L94.9 812.8 L122.3 875.0 L158.5 918.7 L211.7 955.6 L275.3 980.2 L349.0 994.5 L454.9 999.3 L542.3 992.5 L626.4 972.0 L684.4 944.0 L714.5 921.4 L754.1 874.3 L793.0 766.4 L875.0 241.1 L873.0 189.2 L853.8 140.7 L811.5 92.9 L747.3 53.3 L663.3 23.9 L571.0 6.8 L474.7 0.0 L330.6 4.1 L226.8 20.5 Z' } },
  { id:'s', label:'S', cm:'14 cm', refW:668.6, refH:1000.0,
    R:{ vbW:668.6, vbH:1000.0, path:'M199.5 11.4 L119.4 43.8 L74.5 75.0 L33.0 127.3 L7.4 202.4 L0.0 308.1 L4.5 572.5 L22.7 752.1 L47.8 893.7 L65.9 931.2 L97.8 960.2 L200.7 991.5 L353.6 999.4 L507.1 981.8 L542.4 965.9 L574.8 937.5 L603.8 865.3 L665.7 362.7 L666.9 253.6 L654.9 184.8 L612.3 103.5 L562.8 59.1 L503.7 26.7 L443.4 10.2 L352.5 0.6 L239.3 1.1 Z' },
    L:{ vbW:668.6, vbH:1000.0, path:'M199.5 11.4 L119.4 43.8 L74.5 75.0 L33.0 127.3 L7.4 202.4 L0.0 308.1 L4.5 572.5 L22.7 752.1 L47.8 893.7 L65.9 931.2 L97.8 960.2 L200.7 991.5 L353.6 999.4 L507.1 981.8 L542.4 965.9 L574.8 937.5 L603.8 865.3 L665.7 362.7 L666.9 253.6 L654.9 184.8 L612.3 103.5 L562.8 59.1 L503.7 26.7 L443.4 10.2 L352.5 0.6 L239.3 1.1 Z' } },
  { id:'m', label:'M', cm:'16 cm', refW:680.7, refH:1000.0,
    R:{ vbW:680.7, vbH:1000.0, path:'M156.4 24.5 L97.1 54.4 L49.0 95.1 L15.7 141.7 L0.0 187.8 L23.5 597.8 L50.5 803.8 L73.6 916.6 L101.5 953.9 L130.0 971.6 L230.0 990.7 L428.2 999.5 L490.9 995.6 L544.4 981.4 L590.0 949.5 L618.9 900.4 L654.2 682.7 L680.2 386.0 L676.8 226.6 L656.2 140.3 L635.1 103.0 L595.9 64.2 L543.9 32.9 L491.4 16.7 L399.7 2.0 L293.3 0.0 L221.2 7.8 Z' },
    L:{ vbW:680.7, vbH:1000.0, path:'M156.4 24.5 L97.1 54.4 L49.0 95.1 L15.7 141.7 L0.0 187.8 L23.5 597.8 L50.5 803.8 L73.6 916.6 L101.5 953.9 L130.0 971.6 L230.0 990.7 L428.2 999.5 L490.9 995.6 L544.4 981.4 L590.0 949.5 L618.9 900.4 L654.2 682.7 L680.2 386.0 L676.8 226.6 L656.2 140.3 L635.1 103.0 L595.9 64.2 L543.9 32.9 L491.4 16.7 L399.7 2.0 L293.3 0.0 L221.2 7.8 Z' } }
];

const headWord = s => (s || '').trim().toUpperCase().split(/[\s(\u2013-]/)[0];

function hideVariantPickers(){
  const wrappers = document.querySelectorAll(
    'variant-picker, .variant-picker, [class*="variant-picker"], .product-form__variants');
  let done = false;
  wrappers.forEach(w => { if(!HOST.contains(w)){ srOnly(w); done = true; } });
  if(done) return;

  document.querySelectorAll('select').forEach(sel => {
    if(HOST.contains(sel) || sel.dataset.kcHidden) return;
    const isSize = [].slice.call(sel.options)
      .some(o => SIZES.some(s => headWord(o.textContent) === s.label));
    if(!isSize) return;
    srOnly(sel);
    const lab = labelOf(sel);
    if(lab){ lab.style.display = 'none'; lab.dataset.kcHidden = '1'; }
  });

  document.querySelectorAll('input[type="radio"]').forEach(r => {
    if(HOST.contains(r)) return;
    const wrap = r.closest('label, .option, fieldset > div') || r;
    srOnly(wrap);
  });
}

function syncVariantSize(label){
  const want = label.toUpperCase();

  document.querySelectorAll('select').forEach(sel => {
    if(HOST.contains(sel)) return;
    const opt = [].slice.call(sel.options)
      .find(o => headWord(o.textContent) === want || headWord(o.value) === want);
    if(opt && sel.value !== opt.value){
      sel.value = opt.value;
      sel.dispatchEvent(new Event('change', {bubbles:true}));
      sel.dispatchEvent(new Event('input',  {bubbles:true}));
    }
  });

  document.querySelectorAll('input[type="radio"]').forEach(r => {
    if(HOST.contains(r) || r.checked) return;
    const lab = labelOf(r);
    const txt = (lab ? lab.textContent : '') || r.value;
    if(headWord(txt) === want) r.click();
  });
}

const FONTS = [
  {css:'Anton',            label:'Anton'},
  {css:'Bebas Neue',       label:'Bebas'},
  {css:'Archivo Black',    label:'Archivo'},
  {css:'Teko',             label:'Teko'},
  {css:'Permanent Marker', label:'Marker'},
  {css:'Orbitron',         label:'Orbitron'}
];

const PALETTE = ['#FFFFFF','#111111','#E8232A','#1B4FA8','#F5C518','#1E8449','#4FC3F7','#7B1E3C'];

const MAX_BYTES = 850 * 1024;
const COUNTDOWN = 10;

const COUNTRIES = ('fr France,dz Algérie,ma Maroc,tn Tunisie,pt Portugal,es Espagne,it Italie,de Allemagne,be Belgique,ch Suisse,nl Pays-Bas,gb Royaume-Uni,gb-eng Angleterre,gb-sct Écosse,gb-wls Pays de Galles,ie Irlande,br Brésil,ar Argentine,sn Sénégal,ci Côte d\'Ivoire,ml Mali,cm Cameroun,cd RD Congo,cg Congo,ga Gabon,gn Guinée,bf Burkina Faso,tg Togo,bj Bénin,ne Niger,td Tchad,mr Mauritanie,km Comores,mg Madagascar,ng Nigeria,gh Ghana,za Afrique du Sud,eg Égypte,ly Libye,tr Turquie,gr Grèce,pl Pologne,ro Roumanie,rs Serbie,hr Croatie,ba Bosnie-Herzégovine,al Albanie,xk Kosovo,mk Macédoine du Nord,me Monténégro,si Slovénie,sk Slovaquie,cz Tchéquie,hu Hongrie,at Autriche,bg Bulgarie,ua Ukraine,ru Russie,by Biélorussie,md Moldavie,lt Lituanie,lv Lettonie,ee Estonie,fi Finlande,se Suède,no Norvège,dk Danemark,is Islande,lu Luxembourg,mt Malte,cy Chypre,us États-Unis,ca Canada,mx Mexique,co Colombie,cl Chili,pe Pérou,uy Uruguay,py Paraguay,bo Bolivie,ec Équateur,ve Venezuela,cr Costa Rica,pa Panama,gt Guatemala,hn Honduras,sv Salvador,ni Nicaragua,cu Cuba,do République dominicaine,ht Haïti,jm Jamaïque,tt Trinité-et-Tobago,cn Chine,jp Japon,kr Corée du Sud,kp Corée du Nord,in Inde,pk Pakistan,bd Bangladesh,lk Sri Lanka,np Népal,af Afghanistan,ir Iran,iq Irak,sa Arabie saoudite,ae Émirats arabes unis,qa Qatar,kw Koweït,bh Bahreïn,om Oman,ye Yémen,jo Jordanie,lb Liban,sy Syrie,il Israël,ps Palestine,th Thaïlande,vn Viêt Nam,kh Cambodge,la Laos,mm Birmanie,my Malaisie,sg Singapour,id Indonésie,ph Philippines,bn Brunei,tl Timor oriental,mn Mongolie,kz Kazakhstan,uz Ouzbékistan,tm Turkménistan,kg Kirghizistan,tj Tadjikistan,az Azerbaïdjan,am Arménie,ge Géorgie,au Australie,nz Nouvelle-Zélande,fj Fidji,pg Papouasie-Nouvelle-Guinée,nc Nouvelle-Calédonie,pf Polynésie française,ao Angola,mz Mozambique,zw Zimbabwe,zm Zambie,bw Botswana,na Namibie,ke Kenya,tz Tanzanie,ug Ouganda,rw Rwanda,bi Burundi,et Éthiopie,er Érythrée,so Somalie,sd Soudan,ss Soudan du Sud,dj Djibouti,mw Malawi,ls Lesotho,sz Eswatini,mu Maurice,sc Seychelles,cv Cap-Vert,gm Gambie,gw Guinée-Bissau,sl Sierra Leone,lr Liberia,cf Centrafrique,gq Guinée équatoriale,st Sao Tomé-et-Principe,re La Réunion,gp Guadeloupe,mq Martinique,gf Guyane,yt Mayotte,ad Andorre,mc Monaco,sm Saint-Marin,li Liechtenstein,va Vatican').split(',').map(s => { const i = s.indexOf(' '); return {code:s.slice(0,i), name:s.slice(i+1)}; });

function blankSide(){
  return {
    img:null, x:0, y:0, scale:1, rot:0,
    prenom:'', numero:'',
    textPos:{x:0, y:0.28},
    textScale:1, numScale:1, textAlign:'center',
    flagCode:null, flagImg:null,
    flagPos:{x:0, y:-0.26}, flagScale:0.7
  };
}

const state = {
  sizeId:null,
  bg:'#FFFFFF',
  textColor:'#FFFFFF',
  outline:'#000000',
  font:'Anton',
  sameBoth:true,
  fit:'cover',
  target:'R',
  sides:{ R:blankSide(), L:blankSide() }
};

const DPR = Math.min(window.devicePixelRatio || 1, 2.5);
const $ = id => ROOT.getElementById('kc-' + id);
const getSize = () => SIZES.find(s => s.id === state.sizeId);
const flagUrl = (code, w) => 'https://flagcdn.com/w' + w + '/' + code + '.png';
const cur = () => state.sides[state.target];
const sideName = k => k === 'R' ? 'droit' : 'gauche';

const FLAGRECT = {R:null, L:null};
const TEXTRECT = {R:null, L:null};

function fitCanvas(cv, cssW, cssH, ratio){
  const dpr = (ratio === undefined) ? DPR : ratio;
  cv.style.width = cssW + 'px';
  cv.style.height = cssH + 'px';
  cv.width = Math.round(cssW * dpr);
  cv.height = Math.round(cssH * dpr);
  const ctx = cv.getContext('2d');
  ctx.setTransform(dpr,0,0,dpr,0,0);
  ctx.__dpr = dpr;
  return ctx;
}

function shapeRect(W,H,sz,side,inset){
  const k = Math.min((W*inset)/sz.refW, (H*inset)/sz.refH);
  const g = sz[side];
  const w = g.vbW*k, h = g.vbH*k;
  return {x:(W-w)/2, y:(H-h)/2, w, h, k};
}

function applyShapeTransform(ctx, r){
  ctx.translate(r.x, r.y);
  ctx.scale(r.k, r.k);
}

/* La photo remplit toujours toute la forme : aucune bordure, aucun fond visible. */
function coverDims(r, st){
  const swap = Math.abs(Math.sin(st.rot)) > 0.5;
  const bw = swap ? st.img.height : st.img.width;
  const bh = swap ? st.img.width  : st.img.height;
  const s = Math.max(r.w/bw, r.h/bh) * Math.max(1, st.scale);
  return {s:s, w:bw*s, h:bh*s};
}

/* Empeche de deplacer la photo au point de faire apparaitre un bord vide. */
function clampPhoto(r, st){
  if(!st.img) return;
  const d = coverDims(r, st);
  const mx = Math.max(0, (d.w - r.w) / 2) / r.w;
  const my = Math.max(0, (d.h - r.h) / 2) / r.h;
  st.x = Math.max(-mx, Math.min(mx, st.x));
  st.y = Math.max(-my, Math.min(my, st.y));
}

function drawPhoto(ctx, r, st){
  if(!st.img) return;
  clampPhoto(r, st);
  const d = coverDims(r, st);
  ctx.save();
  ctx.translate(r.x + r.w/2 + st.x*r.w, r.y + r.h/2 + st.y*r.h);
  ctx.rotate(st.rot);
  ctx.scale(d.s, d.s);
  ctx.drawImage(st.img, -st.img.width/2, -st.img.height/2);
  ctx.restore();
}

/* Le drapeau est un element libre : le client le pose ou il veut. */
function drawFlag(ctx, r, s, side, track){
  if(track) FLAGRECT[side] = null;
  if(!s.flagImg) return;
  const h = r.w * 0.26 * s.flagScale;
  const w = h * (s.flagImg.width / s.flagImg.height);
  const cx = r.x + r.w/2 + s.flagPos.x * r.w;
  const cy = r.y + r.h/2 + s.flagPos.y * r.h;
  const bx = cx - w/2, by = cy - h/2;
  ctx.save();
  ctx.shadowColor = 'rgba(0,0,0,.4)';
  ctx.shadowBlur = h*0.16;
  ctx.drawImage(s.flagImg, bx, by, w, h);
  ctx.restore();
  if(track) FLAGRECT[side] = {x:bx, y:by, w:w, h:h};
}

function drawText(ctx, r, side, track){
  if(track) TEXTRECT[side] = null;
  const s = state.sides[side];
  const prenom = s.prenom.trim();
  const num    = s.numero.trim();
  if(!prenom && !num) return;

  const unit = r.w * 0.17 * s.textScale;
  const rows = [];
  if(prenom) rows.push({t:prenom, s:unit*0.80});
  if(num)    rows.push({t:num,    s:unit*1.75*s.numScale});

  const al = s.textAlign;
  let ax;
  if(al === 'left')       ax = r.x + r.w*0.16 + s.textPos.x * r.w;
  else if(al === 'right') ax = r.x + r.w*0.84 + s.textPos.x * r.w;
  else                    ax = r.x + r.w/2    + s.textPos.x * r.w;
  const cy = r.y + r.h/2 + s.textPos.y * r.h;

  const gap = unit*0.12;
  const total = rows.reduce((a,x)=>a+x.s,0) + gap*Math.max(0, rows.length-1);
  let y = cy - total/2;
  const top = y;
  let maxW = 0;

  ctx.save();
  ctx.textAlign = (al === 'left') ? 'left' : (al === 'right' ? 'right' : 'center');
  ctx.textBaseline = 'top';
  ctx.lineJoin = 'round';
  for(const row of rows){
    ctx.font = row.s + 'px "' + state.font + '", sans-serif';
    maxW = Math.max(maxW, ctx.measureText(row.t).width);
    if(state.outline !== 'none'){
      ctx.strokeStyle = state.outline;
      ctx.lineWidth = row.s * 0.11;
      ctx.strokeText(row.t, ax, y);
    }
    ctx.fillStyle = state.textColor;
    ctx.fillText(row.t, ax, y);
    y += row.s + gap;
  }
  ctx.restore();

  if(track){
    let bx = ax - maxW/2;
    if(al === 'left') bx = ax;
    else if(al === 'right') bx = ax - maxW;
    TEXTRECT[side] = {x:bx, y:top, w:maxW, h:total};
  }
}

/* Cadre pointille + etiquette "deplacer" autour du texte / drapeau (apercu seulement). */
function drawHandle(ctx, rc, W){
  if(!rc) return;
  const p = 4;
  ctx.save();
  ctx.setLineDash([5,4]);
  ctx.lineWidth = 1.6;
  ctx.strokeStyle = '#FFFFFF';
  ctx.shadowColor = 'rgba(0,0,0,.7)';
  ctx.shadowBlur = 3;
  ctx.strokeRect(rc.x - p, rc.y - p, rc.w + 2*p, rc.h + 2*p);
  ctx.setLineDash([]);
  ctx.shadowBlur = 0;
  const label = '\u270B D\u00e9place-moi';
  ctx.font = '700 11px Inter, system-ui, sans-serif';
  const tw = ctx.measureText(label).width + 12;
  let bx = rc.x + rc.w/2 - tw/2;
  bx = Math.max(2, Math.min(W - tw - 2, bx));
  let by = rc.y - p - 20;
  if(by < 2) by = rc.y + rc.h + p + 4;
  ctx.fillStyle = '#E8232A';
  ctx.fillRect(bx, by, tw, 17);
  ctx.fillStyle = '#FFFFFF';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(label, bx + tw/2, by + 9);
  ctx.restore();
}

function drawGuard(ctx, W, H, side, opt){
  opt = opt || {};
  const sz = getSize(); if(!sz) return;
  const dpr = ctx.__dpr || DPR;
  const inset = (opt.inset === undefined) ? 0.98 : opt.inset;
  const r = shapeRect(W, H, sz, side, inset);
  const st = state.sides[side];
  const path = new Path2D(sz[side].path);

  ctx.clearRect(0,0,W,H);
  if(opt.flatten){
    ctx.fillStyle = '#FFFFFF';
    ctx.fillRect(0,0,W,H);
  }

  ctx.save();
  applyShapeTransform(ctx, r);
  ctx.clip(path);
  ctx.setTransform(dpr,0,0,dpr,0,0);

  ctx.fillStyle = state.bg;
  ctx.fillRect(0,0,W,H);
  drawPhoto(ctx, r, st);
  drawFlag(ctx, r, st, side, !!opt.track);
  drawText(ctx, r, side, !!opt.track);
  ctx.restore();

  if(opt.stroke !== false){
    ctx.save();
    applyShapeTransform(ctx, r);
    ctx.strokeStyle = 'rgba(242,244,241,.45)';
    ctx.lineWidth = 1.6 / r.k;
    ctx.stroke(path);
    ctx.restore();
  }

  if(opt.track && side === state.target){
    drawHandle(ctx, TEXTRECT[side], W);
    drawHandle(ctx, FLAGRECT[side], W);
  }
  return r;
}

let rectR = null, rectL = null;

function renderPreview(){
  const sz = getSize();
  $('emptyState').hidden = !!sz;
  $('guards').hidden = !sz;
  $('specLabel').textContent = sz ? (sz.label + ' \u00b7 ' + sz.cm) : '\u2014';
  if(!sz) return;

  const box = $('cvR').parentElement.getBoundingClientRect().width || 200;
  const w = Math.max(120, box);
  const h = w * (sz.refH / sz.refW);

  rectR = drawGuard(fitCanvas($('cvR'), w, h), w, h, 'R', {track:true});
  rectL = drawGuard(fitCanvas($('cvL'), w, h), w, h, 'L', {track:true});

  ['R','L'].forEach(k => {
    const col = $('cv'+k).closest('.guard');
    col.classList.toggle('kc-on',  state.target === k);
    col.classList.toggle('kc-off', state.target !== k);
  });

  const s = cur();
  $('stageHint').textContent = (s.img || s.prenom || s.numero || s.flagImg)
    ? '\uD83D\uDC46 Fais glisser avec ton doigt pour placer la photo, le texte et le drapeau' : '';
}

function inRect(rc, px, py, pad){
  return rc && px >= rc.x - pad && px <= rc.x + rc.w + pad && py >= rc.y - pad && py <= rc.y + rc.h + pad;
}

/* Un doigt sur le drapeau = drapeau, sur le texte = texte, ailleurs = la photo. */
function attachDrag(cv, side, getRect){
  let mode = null, lastX = 0, lastY = 0;
  cv.addEventListener('pointerdown', e => {
    const s = state.sides[side];
    const box = cv.getBoundingClientRect();
    const px = e.clientX - box.left, py = e.clientY - box.top;
    if(s.flagImg && inRect(FLAGRECT[side], px, py, 10)){
      mode = 'flag';
    } else if(hasText(s) && inRect(TEXTRECT[side], px, py, 14)){
      mode = 'text';
    } else if(s.img){
      mode = 'photo';
    } else if(hasText(s)){
      mode = 'text';
    } else if(s.flagImg){
      mode = 'flag';
    } else return;
    state.target = side;
    syncTargetButtons();
    loadTargetIntoUI();
    lastX = e.clientX; lastY = e.clientY;
    cv.setPointerCapture(e.pointerId); e.preventDefault();
  });
  cv.addEventListener('pointermove', e => {
    if(!mode) return;
    const r = getRect(); if(!r) return;
    const s = state.sides[side];
    const dx = (e.clientX - lastX) / r.w;
    const dy = (e.clientY - lastY) / r.h;
    lastX = e.clientX; lastY = e.clientY;
    if(mode === 'photo'){
      s.x += dx; s.y += dy;
      clampPhoto(r, s);
      if(state.sameBoth){
        const o = state.sides[side === 'R' ? 'L' : 'R'];
        o.x = s.x; o.y = s.y;
      }
    } else {
      const p = mode === 'flag' ? s.flagPos : s.textPos;
      p.x = Math.max(-0.45, Math.min(0.45, p.x + dx));
      p.y = Math.max(-0.45, Math.min(0.45, p.y + dy));
    }
    renderPreview();
  });
  const stop = () => { mode = null; };
  cv.addEventListener('pointerup', stop);
  cv.addEventListener('pointercancel', stop);
  cv.style.touchAction = 'none';
}

let editSide = null;

function renderEditor(){
  const sz = getSize(); if(!sz || !editSide) return;
  const st = state.sides[editSide];
  if(!st.img) return;

  const sheetW = $('editCanvas').parentElement.clientWidth - 36;
  const W = Math.max(220, Math.min(380, sheetW));
  const H = Math.round(W * 1.28);
  const ctx = fitCanvas($('editCanvas'), W, H);
  const r = shapeRect(W, H, sz, editSide, 0.80);
  const path = new Path2D(sz[editSide].path);

  ctx.clearRect(0,0,W,H);
  drawPhoto(ctx, r, st);
  ctx.fillStyle = 'rgba(8,13,11,.72)';
  ctx.fillRect(0,0,W,H);

  ctx.save();
  applyShapeTransform(ctx, r);
  ctx.clip(path);
  ctx.setTransform(DPR,0,0,DPR,0,0);
  ctx.fillStyle = state.bg;
  ctx.fillRect(0,0,W,H);
  drawPhoto(ctx, r, st);
  drawFlag(ctx, r, st, editSide, false);
  drawText(ctx, r, editSide, false);
  ctx.restore();

  ctx.save();
  applyShapeTransform(ctx, r);
  ctx.strokeStyle = '#F2F4F1';
  ctx.lineWidth = 2 / r.k;
  ctx.setLineDash([9/r.k, 7/r.k]);
  ctx.stroke(path);
  ctx.restore();
}

function openEditor(side){
  editSide = side;
  $('editTitle').textContent = 'Cadre ta photo \u2014 ' + sideName(side);
  $('editModal').classList.add('open');
  requestAnimationFrame(renderEditor);
}
function closeEditor(){
  $('editModal').classList.remove('open');
  editSide = null;
  syncUI();
  renderPreview();
}

function editStep(fn){
  if(!editSide) return;
  fn(state.sides[editSide]);
  if(state.sameBoth){
    const o = state.sides[editSide === 'R' ? 'L' : 'R'];
    const s = state.sides[editSide];
    o.x = s.x; o.y = s.y; o.scale = s.scale; o.rot = s.rot;
  }
  renderEditor();
}

$('tIn').onclick   = () => editStep(s => s.scale = Math.min(6, s.scale * 1.15));
$('tOut').onclick  = () => editStep(s => s.scale = Math.max(1, s.scale / 1.15));
$('tRotL').onclick = () => editStep(s => s.rot -= Math.PI/2);
$('tRotR').onclick = () => editStep(s => s.rot += Math.PI/2);
$('tOk').onclick   = closeEditor;
$('tDel').onclick  = () => {
  const s = state.sides[editSide];
  s.img = null; s.x = 0; s.y = 0; s.scale = 1; s.rot = 0;
  if(state.sameBoth){
    const o = state.sides[editSide === 'R' ? 'L' : 'R'];
    o.img = null; o.x = 0; o.y = 0; o.scale = 1; o.rot = 0;
  }
  closeEditor();
};

(function editorDrag(){
  const cv = $('editCanvas');
  let dragging = false, lastX = 0, lastY = 0;
  cv.addEventListener('pointerdown', e => {
    dragging = true; lastX = e.clientX; lastY = e.clientY;
    cv.setPointerCapture(e.pointerId); e.preventDefault();
  });
  cv.addEventListener('pointermove', e => {
    if(!dragging || !editSide) return;
    const sz = getSize();
    const r = shapeRect(cv.clientWidth, cv.clientHeight, sz, editSide, 0.80);
    const dx = (e.clientX - lastX) / r.w;
    const dy = (e.clientY - lastY) / r.h;
    lastX = e.clientX; lastY = e.clientY;
    editStep(s => { s.x += dx; s.y += dy; });
  });
  const stop = () => { dragging = false; };
  cv.addEventListener('pointerup', stop);
  cv.addEventListener('pointercancel', stop);
})();

/* La photo est posee automatiquement, sans ouvrir d'editeur. */
function loadFile(file, side){
  if(!file) return;
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => {
    const s = state.sides[side];
    s.img = img; s.x = 0; s.y = 0; s.scale = 1; s.rot = 0;
    if(state.sameBoth){
      const o = state.sides[side === 'R' ? 'L' : 'R'];
      o.img = img; o.x = 0; o.y = 0; o.scale = 1; o.rot = 0;
    }
    syncUI();
    renderPreview();
  };
  img.onerror = () => alert("Cette image n'a pas pu \u00eatre ouverte. Essaie une autre photo.");
  img.src = url;
}

$('fileR').addEventListener('change', e => { loadFile(e.target.files[0], 'R'); e.target.value=''; });
$('fileL').addEventListener('change', e => { loadFile(e.target.files[0], 'L'); e.target.value=''; });

$('sameBoth').addEventListener('change', e => {
  state.sameBoth = e.target.checked;
  if(state.sameBoth && state.sides.R.img){
    const s = state.sides.R, o = state.sides.L;
    o.img = s.img; o.x = s.x; o.y = s.y; o.scale = s.scale; o.rot = s.rot;
  }
  syncUI();
  renderPreview();
});

SIZES.forEach(sz => {
  const b = document.createElement('button');
  b.className = 'size-btn';
  b.type = 'button';
  b.setAttribute('aria-pressed','false');
  b.innerHTML = sz.label + '<small>' + sz.cm + '</small>';
  b.onclick = () => {
    state.sizeId = sz.id;
    ['R','L'].forEach(k => { const s = state.sides[k]; s.x = 0; s.y = 0; s.scale = 1; });
    syncVariantSize(sz.label);
    syncUI();
    renderPreview();
  };
  $('sizes').appendChild(b);
});

FONTS.forEach(f => {
  const b = document.createElement('button');
  b.className = 'font-btn';
  b.type = 'button';
  b.style.fontFamily = '"' + f.css + '", sans-serif';
  b.textContent = f.label;
  b.setAttribute('aria-pressed', String(f.css === state.font));
  b.onclick = async () => {
    state.font = f.css;
    try { await document.fonts.load('40px "' + f.css + '"'); } catch(e){}
    syncUI();
    renderPreview();
  };
  $('fonts').appendChild(b);
});

/* Deux onglets seulement : on travaille sur un protege-tibia a la fois. */
const targetHost = $('textSide');
(function setupTarget(){
  const lab = targetHost.previousElementSibling;
  if(lab) lab.textContent = 'Je personnalise le prot\u00e8ge-tibia';
  targetHost.innerHTML =
    '<button type="button" class="seg" data-v="R" aria-pressed="true">DROIT</button>' +
    '<button type="button" class="seg" data-v="L" aria-pressed="false">GAUCHE</button>';

  const copy = document.createElement('button');
  copy.type = 'button';
  copy.className = 'kc-copy';
  copy.textContent = 'Copier sur l\'autre prot\u00e8ge-tibia';
  targetHost.parentElement.appendChild(copy);

  const note = document.createElement('p');
  note.className = 'kc-note2';
  note.textContent = 'Le prot\u00e8ge-tibia choisi est mis en avant dans l\'aper\u00e7u, l\'autre reste gris\u00e9.';
  targetHost.parentElement.appendChild(note);

  targetHost.addEventListener('click', e => {
    const b = e.target.closest('.seg'); if(!b) return;
    state.target = b.dataset.v;
    syncTargetButtons();
    loadTargetIntoUI();
    renderPreview();
  });

  copy.addEventListener('click', () => {
    const s = cur(), o = state.sides[state.target === 'R' ? 'L' : 'R'];
    o.prenom = s.prenom; o.numero = s.numero;
    o.textScale = s.textScale; o.numScale = s.numScale;
    o.textAlign = s.textAlign;
    o.textPos = {x:s.textPos.x, y:s.textPos.y};
    o.flagCode = s.flagCode; o.flagImg = s.flagImg;
    o.flagScale = s.flagScale;
    o.flagPos = {x:s.flagPos.x, y:s.flagPos.y};
    renderPreview();
    syncUI();
  });
})();

function syncTargetButtons(){
  [].slice.call(targetHost.children).forEach(b =>
    b.setAttribute('aria-pressed', String(b.dataset.v === state.target)));
}

/* Le champ Nom disparait : prenom et numero suffisent. */
(function dropNom(){
  const f = $('nom').closest('.field');
  if(f) f.style.display = 'none';
})();

/* Plus de mode "en fond" : le drapeau se pose librement. */
$('flagMode').closest('.field').style.display = 'none';

/* Simplification : plus de boutons d'alignement, on deplace le texte au doigt. */
(function simplifyText(){
  const al = $('textAlign');
  const f = al && al.closest('.field');
  if(f) f.style.display = 'none';
  const tip = document.createElement('p');
  tip.className = 'kc-tip';
  tip.textContent = '\uD83D\uDC46 Ton texte appara\u00eet sur l\'aper\u00e7u : pose ton doigt dessus et fais-le glisser pour le placer o\u00f9 tu veux.';
  $('card3').appendChild(tip);
})();

/* Photo : une astuce simple pour la recentrer au doigt. */
(function photoTip(){
  const tip = document.createElement('p');
  tip.className = 'kc-tip';
  tip.textContent = '\uD83D\uDC46 Ta photo remplit tout le prot\u00e8ge-tibia. Fais-la glisser sur l\'aper\u00e7u pour bien centrer le visage.';
  $('card2').appendChild(tip);
})();

function loadTargetIntoUI(){
  const s = cur();
  $('prenom').value = s.prenom;
  $('numero').value = s.numero;
  $('tsize').value  = s.textScale;
  $('nsize').value  = s.numScale;
  const fs = $('fsize'); if(fs) fs.value = s.flagScale;
  [].slice.call($('textAlign').children).forEach(b =>
    b.setAttribute('aria-pressed', String(b.dataset.v === s.textAlign)));
  renderFlagList($('flagSearch').value);
  syncUI();
}

$('textAlign').addEventListener('click', e => {
  const b = e.target.closest('.seg'); if(!b) return;
  cur().textAlign = b.dataset.v;
  [].slice.call($('textAlign').children).forEach(x =>
    x.setAttribute('aria-pressed', String(x === b)));
  renderPreview();
});

(function buildFlagTools(){
  const tip = document.createElement('p');
  tip.className = 'kc-tip';
  tip.textContent = '\uD83D\uDC46 Choisis ton drapeau, puis pose ton doigt dessus sur l\'aper\u00e7u et fais-le glisser pour le placer.';
  $('card6').appendChild(tip);

  const field = document.createElement('div');
  field.className = 'field';
  field.style.marginTop = '12px';
  field.innerHTML =
    '<label class="lbl" for="kc-fsize">Taille du drapeau</label>' +
    '<input type="range" id="kc-fsize" min="0.3" max="2.5" step="0.05" value="0.7">';
  $('card6').appendChild(field);
  field.querySelector('input').addEventListener('input', e => {
    cur().flagScale = parseFloat(e.target.value);
    renderPreview();
  });

  const rm = document.createElement('button');
  rm.type = 'button';
  rm.className = 'kc-copy';
  rm.textContent = 'Retirer le drapeau';
  $('card6').appendChild(rm);
  rm.addEventListener('click', () => {
    const s = cur();
    s.flagCode = null; s.flagImg = null;
    renderFlagList($('flagSearch').value);
    syncUI();
    renderPreview();
  });
})();

function renderFlagList(filter){
  const host = $('flags');
  host.innerHTML = '';
  const q = (filter||'').trim().toLowerCase();
  const list = q
    ? COUNTRIES.filter(c => c.name.toLowerCase().indexOf(q) !== -1)
    : COUNTRIES;
  if(!list.length){
    host.innerHTML = '<p class="flag-none">Aucun pays trouv\u00e9.</p>';
    return;
  }
  const active = cur().flagCode;
  list.slice(0, 260).forEach(c => {
    const b = document.createElement('button');
    b.className = 'flag-btn';
    b.type = 'button';
    b.title = c.name;
    b.setAttribute('aria-label', c.name);
    b.setAttribute('aria-pressed', String(c.code === active));
    b.innerHTML = '<img loading="lazy" alt="" src="' + flagUrl(c.code, 80) + '">';
    b.onclick = () => pickFlag(c.code);
    host.appendChild(b);
  });
}

function pickFlag(code){
  const s = cur();
  const img = new Image();
  img.crossOrigin = 'anonymous';
  img.onload = () => { s.flagImg = img; syncUI(); renderPreview(); if(editSide) renderEditor(); };
  img.onerror = () => { s.flagImg = null; };
  img.src = flagUrl(code, 1280);
  s.flagCode = code;
  renderFlagList($('flagSearch').value);
  syncUI();
}

$('flagSearch').addEventListener('input', e => renderFlagList(e.target.value));

function buildSwatches(host, key){
  PALETTE.forEach(c => {
    const b = document.createElement('button');
    b.className = 'sw';
    b.type = 'button';
    b.style.background = c;
    b.setAttribute('aria-label', 'Couleur ' + c);
    b.setAttribute('aria-pressed', String(state[key] === c));
    b.onclick = () => { state[key] = c; syncUI(); renderPreview(); };
    host.appendChild(b);
  });
  const inp = document.createElement('input');
  inp.type = 'color';
  inp.className = 'sw-custom';
  inp.value = state[key];
  inp.setAttribute('aria-label','Couleur personnalis\u00e9e');
  inp.oninput = () => { state[key] = inp.value; syncUI(); renderPreview(); };
  host.appendChild(inp);
}
buildSwatches($('bgSw'), 'bg');
buildSwatches($('txSw'), 'textColor');

$('outline').addEventListener('change', e => { state.outline = e.target.value; renderPreview(); });

['prenom','numero'].forEach(k => {
  $(k).addEventListener('input', e => {
    let v = e.target.value;
    if(k === 'numero'){ v = v.replace(/\D/g,''); e.target.value = v; }
    cur()[k] = v;
    syncUI();
    renderPreview();
  });
});

$('tsize').addEventListener('input', e => {
  cur().textScale = parseFloat(e.target.value);
  renderPreview();
});
$('nsize').addEventListener('input', e => {
  cur().numScale = parseFloat(e.target.value);
  renderPreview();
});

function hasText(s){ return !!(s.prenom || s.numero); }

function syncUI(){
  const sz = getSize();

  [].slice.call($('sizes').children).forEach((b,i) =>
    b.setAttribute('aria-pressed', String(SIZES[i].id === state.sizeId)));
  [].slice.call($('fonts').children).forEach((b,i) =>
    b.setAttribute('aria-pressed', String(FONTS[i].css === state.font)));
  [].slice.call($('bgSw').querySelectorAll('.sw')).forEach((b,i) =>
    b.setAttribute('aria-pressed', String(PALETTE[i] === state.bg)));
  [].slice.call($('txSw').querySelectorAll('.sw')).forEach((b,i) =>
    b.setAttribute('aria-pressed', String(PALETTE[i] === state.textColor)));

  const picked = COUNTRIES.find(c => c.code === cur().flagCode);
  const pick = $('flagPick');
  pick.hidden = !picked;
  if(picked){
    pick.innerHTML = '<img alt="" src="' + flagUrl(picked.code, 80) + '"><span>' +
      picked.name + ' \u00b7 tibia ' + sideName(state.target) + '</span>';
  }

  $('card1').classList.toggle('done', !!sz);
  [2,3,4,5,6].forEach(n => $('card'+n).setAttribute('aria-disabled', String(!sz)));

  const hasR = !!state.sides.R.img, hasL = !!state.sides.L.img;
  $('upR').classList.toggle('filled', hasR);
  $('upL').classList.toggle('filled', hasL);
  $('upR').querySelector('.u-act').textContent = hasR ? 'Changer' : 'Importer';
  $('upL').querySelector('.u-act').textContent = hasL ? 'Changer' : 'Importer';
  $('card2').classList.toggle('done', hasR && hasL);
  $('card3').classList.toggle('done', hasText(state.sides.R) || hasText(state.sides.L));
  $('card4').classList.toggle('done', hasR || hasL);
  $('card5').classList.toggle('done', hasR || hasL);
  $('card6').classList.toggle('done', !!(state.sides.R.flagImg || state.sides.L.flagImg));

  $('addBtn').disabled = !(sz && hasR && hasL);
}

function sideSummary(k){
  const s = state.sides[k];
  const picked = COUNTRIES.find(c => c.code === s.flagCode);
  const txt = [s.prenom, s.numero].filter(Boolean).join(' \u00b7 ') || '\u2014';
  return {txt, flagTxt: picked ? picked.name : '\u2014'};
}

$('addBtn').onclick = () => {
  const sz = getSize();
  const w = 150, h = w * (sz.refH / sz.refW);
  drawGuard(fitCanvas($('rcR'), w, h), w, h, 'R', {stroke:false, inset:1});
  drawGuard(fitCanvas($('rcL'), w, h), w, h, 'L', {stroke:false, inset:1});

  const R = sideSummary('R'), L = sideSummary('L');
  const rows = [
    ['Taille', sz.label + ' \u2014 ' + sz.cm],
    ['Droit \u00b7 texte', R.txt],
    ['Droit \u00b7 drapeau', R.flagTxt],
    ['Gauche \u00b7 texte', L.txt],
    ['Gauche \u00b7 drapeau', L.flagTxt],
    ['Police', state.font]
  ];
  $('recapLines').innerHTML = rows
    .map(p => '<div><span>' + p[0] + '</span><b>' + p[1] + '</b></div>').join('');
  $('recapModal').classList.add('open');
};

$('backBtn').onclick = () => $('recapModal').classList.remove('open');

function openCountdown(seconds){
  const ov = document.createElement('div');
  ov.style.cssText = 'position:fixed;inset:0;z-index:2147483600;background:rgba(6,10,9,.94);' +
    'display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px;' +
    'padding:24px;text-align:center;color:#F2F4F1;font-family:Inter,system-ui,sans-serif;';
  const ring = document.createElement('div');
  ring.style.cssText = 'width:112px;height:112px;border-radius:50%;border:3px solid #2C3833;' +
    'border-top-color:#E8232A;display:flex;align-items:center;justify-content:center;' +
    'animation:kcspin 1s linear infinite;';
  const num = document.createElement('div');
  num.style.cssText = 'font-family:"Barlow Condensed",sans-serif;font-weight:700;font-size:52px;' +
    'line-height:1;color:#F2F4F1;animation:kcspin 1s linear infinite reverse;';
  ring.appendChild(num);
  const title = document.createElement('div');
  title.style.cssText = 'font-family:"Barlow Condensed",sans-serif;font-weight:700;font-size:20px;' +
    'letter-spacing:.1em;text-transform:uppercase;';
  title.textContent = 'Pr\u00e9paration de ta maquette';
  const sub = document.createElement('div');
  sub.style.cssText = 'font-size:14px;color:#8A9791;max-width:290px;line-height:1.5;';
  sub.textContent = 'On g\u00e9n\u00e8re tes deux prot\u00e8ge-tibias puis on les ajoute au panier. Ne ferme pas la page.';

  ov.appendChild(ring); ov.appendChild(title); ov.appendChild(sub);
  ROOT.appendChild(ov);

  let n = seconds;
  num.textContent = n;
  const done = new Promise(res => {
    const iv = setInterval(() => {
      n -= 1;
      num.textContent = n > 0 ? n : '\u2713';
      if(n <= 0){ clearInterval(iv); res(); }
    }, 1000);
  });
  return { done, close: () => ov.remove() };
}

function renderExport(side, width, type, quality, flatten){
  const sz = getSize();
  const h = Math.round(width * (sz.refH / sz.refW));
  const cv = document.createElement('canvas');
  const ctx = fitCanvas(cv, width, h, 1);
  drawGuard(ctx, width, h, side, {stroke:false, inset:1, flatten:flatten});
  return new Promise(res => cv.toBlob(res, type, quality));
}

async function exportBlob(side){
  const steps = [1400, 1150, 950];
  let last = null;
  for(const w of steps){
    const blob = await renderExport(side, w, 'image/png');
    if(blob && blob.size <= MAX_BYTES) return blob;
    last = blob;
  }
  for(const conf of [[1400,0.88],[1150,0.82],[950,0.78]]){
    const blob = await renderExport(side, conf[0], 'image/jpeg', conf[1], true);
    if(blob && blob.size <= MAX_BYTES) return blob;
    last = blob;
  }
  return last;
}

function pick(sel, nth){
  if(sel){ try { return document.querySelector(sel); } catch(e){ return null; } }
  const all = [].slice.call(document.querySelectorAll('input[type=file]'))
                .filter(el => !HOST.contains(el));
  return all[nth] || null;
}

function setFile(input, file){
  if(!input) return false;
  try {
    const dt = new DataTransfer();
    dt.items.add(file);
    input.files = dt.files;
    input.dispatchEvent(new Event('change', {bubbles:true}));
    input.dispatchEvent(new Event('input',  {bubbles:true}));
    return true;
  } catch(e){ return false; }
}

function setText(sel, value){
  if(!sel) return;
  let el; try { el = document.querySelector(sel); } catch(e){ return; }
  if(!el) return;
  el.value = value;
  el.dispatchEvent(new Event('change', {bubbles:true}));
  el.dispatchEvent(new Event('input',  {bubbles:true}));
}

function named(blob, base){
  const ext = (blob.type === 'image/jpeg') ? '.jpg' : '.png';
  return new File([blob], base + ext, {type: blob.type});
}

async function cartCount(){
  try {
    const r = await fetch('/cart.js', {headers:{'Accept':'application/json'}});
    const j = await r.json();
    return (typeof j.item_count === 'number') ? j.item_count : null;
  } catch(e){ return null; }
}

function spinOn(btn, text){
  btn.classList.add('validated');
  btn.innerHTML = '<span class="kc-spin"></span>' + text;
}

async function waitForCart(before){
  if(before === null){ await new Promise(r => setTimeout(r, 2200)); return; }
  const deadline = Date.now() + 12000;
  while(Date.now() < deadline){
    await new Promise(r => setTimeout(r, 600));
    const now = await cartCount();
    if(now !== null && now > before) return;
  }
}

$('confirmBtn').onclick = async () => {
  const btn = $('confirmBtn');
  const addBtn = $('addBtn');
  btn.disabled = true;
  btn.textContent = 'Pr\u00e9paration de ta maquette\u2026';

  const cd = openCountdown(COUNTDOWN);
  const before = await cartCount();

  try {
    const sz = getSize();
    syncVariantSize(sz.label);

    const pair = await Promise.all([exportBlob('R'), exportBlob('L')]);
    if(!pair[0] || !pair[1]) throw new Error('export vide');

    const okR = setFile(pick(CFG.fileRight, 0), named(pair[0], 'kingcase-droit'));
    const okL = setFile(pick(CFG.fileLeft, 1),  named(pair[1], 'kingcase-gauche'));

    const R = sideSummary('R'), L = sideSummary('L');
    setText(CFG.textPrenom, 'Droit: ' + R.txt + ' | Gauche: ' + L.txt);
    setText(CFG.textNom,    'Drapeaux \u2014 droit: ' + R.flagTxt + ' | gauche: ' + L.flagTxt);
    setText(CFG.textPolice, state.font);
    setText(CFG.textTaille, sz.label + ' (' + sz.cm + ')');

    if(!okR && !okL){
      cd.close();
      btn.disabled = false;
      btn.textContent = 'Valider et ajouter au panier';
      $('kcErr').hidden = false;
      return;
    }

    let adding = null;
    if(CFG.autoSubmit === 'true' && CFG.addBtn){
      const real = document.querySelector(CFG.addBtn);
      if(real){ real.click(); adding = waitForCart(before); }
    }

    await cd.done;
    cd.close();
    $('recapModal').classList.remove('open');

    if(adding){
      spinOn(addBtn, 'Ajout au panier\u2026');
      await adding;
    }

    addBtn.classList.add('validated');
    addBtn.innerHTML = '\u2713 Ajout\u00e9 au panier';
    $('kcDone').hidden = false;

    trigger.textContent = '\u2713 Personnalisation valid\u00e9e \u2014 modifier';
    trigger.style.background = '#3FB27F';
    trigger.style.color = '#08150F';
    setTimeout(closeApp, 1400);
  } catch(e){
    console.error('[KingCase]', e);
    cd.close();
    btn.disabled = false;
    btn.textContent = 'Valider et ajouter au panier';
    addBtn.classList.remove('validated');
    addBtn.innerHTML = 'Voir mon rendu';
    $('kcErr').hidden = false;
  }
};

document.addEventListener('keydown', e => {
  if(e.key !== 'Escape') return;
  if($('editModal').classList.contains('open')) closeEditor();
  else if($('recapModal').classList.contains('open')) $('recapModal').classList.remove('open');
  else if(HOST.style.display === 'block') closeApp();
});

let t;
window.addEventListener('resize', () => {
  clearTimeout(t);
  t = setTimeout(() => { renderPreview(); if(editSide) renderEditor(); }, 90);
});

attachDrag($('cvR'), 'R', () => rectR);
attachDrag($('cvL'), 'L', () => rectL);

function cleanup(){ hideLegacyBlocks(); hideVariantPickers(); }
cleanup();
setTimeout(cleanup, 800);
setTimeout(cleanup, 2500);

document.fonts.ready.then(() => { syncUI(); renderPreview(); });
syncTargetButtons();
renderFlagList('');
loadTargetIntoUI();
renderPreview();

})();
